import { BRAND } from '@utils/settings'
import {
  FAQPageJsonLd,
  OrganizationJsonLd,
  BreadcrumbJsonLd,
  NewsArticleJsonLd,
  SiteLinksSearchBoxJsonLd,
} from 'next-seo'
import Script from 'next/script'

interface Props {
  item?: any
  type?: string
}

const JsonLd = (props: Props) => {
  const { item = undefined, type = '' } = props

  switch (type) {
    case 'organization': {
      return (
        <OrganizationJsonLd
          type="Organization" // @TODO
          name={BRAND}
          legalName="Emilceramica S.r.l."
          id="https://www.emilgroup.it"
          url="https://www.emilgroup.it"
          logo={`https://www.emilgroup.it/images/logo.png`}
          image={`https://www.emilgroup.it/images/logo.png`}
          telephone={''} // @TODO
          address={{}} // @TODO
          contactPoint={[]} // @TODO
        />
      )
    }
    case 'breadcrumbs': {
      return <BreadcrumbJsonLd itemListElements={item} />
    }
    case 'faq': {
      return <FAQPageJsonLd mainEntity={item} />
    }
    case 'news': {
      return <NewsArticleJsonLd {...item} />
    }
    case 'search': {
      return (
        <SiteLinksSearchBoxJsonLd
          url="https://www.emilgroup.it"
          potentialActions={[
            {
              target: `https://www.emilgroup.it/ricerca?q`, // @TODO
              queryInput: 'search_term_string',
            },
          ]}
        />
      )
    }
    case 'prodotto': {
      try {
        const json = JSON.stringify(item)
        return (
          <Script
            id="product-markup"
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: json }}
            strategy="beforeInteractive"
          />
        )
      } catch {
        return null
      }
    }
    default: {
      return null
    }
  }
}

export default JsonLd
